import React from 'react';

import RouteSwitch from '@app/routes/RouteSwitch';
import RouteConfigType from '@app/types/RouteConfigType';

const ManualRoutingPage = React.lazy(() => import('@pages/ManualRouting'));

const manualRoutingRoutes: RouteConfigType[] = [
  {
    component: RouteSwitch,
    path: '/manual-routing',
    title: 'Manual Routing',
    exact: false,
    guard: [],
    useInBreadcrumbs: false,
    routes: [
      {
        component: ManualRoutingPage,
        path: '/manual-routing',
        title: 'Manual Routing',
        exact: true,
        guard: [],
        useInBreadcrumbs: false,
      },
    ],
  },
];

export default manualRoutingRoutes;
